<ui-card [headline]="headline$|async" [cardToolBarItems]="menuItems$|async" [isExpanded]="true">
  <div *ngIf="itemData$|async;let itemData">
    <ui-table *ngIf="itemData.length > 0" (rowClicked)="onRowClicked($event)" [data]="itemData" fxLayout="column" [actionMenu]="actionMenu" >
      <ui-table-column name="name" headerName="Report"></ui-table-column>
      <ui-table-column name="paramSummary" headerName="Params" ></ui-table-column>
    </ui-table>
  </div>
</ui-card>
